import { motion } from 'framer-motion';
import { FITTINGS } from './data';

// FITTINGS — six numbered chapters, each on a "chapter page" of the folio.
export default function Fittings({ setPage }) {
  return (
    <div className="bg-[#E5DDCB] text-[#1F1E1B] relative">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{ backgroundImage: 'linear-gradient(#1F1E1B 1px, transparent 1px), linear-gradient(90deg, #1F1E1B 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
      <section className="relative pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#1F1E1B]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#6B2D2A] mb-4">— Folio III · The six fittings</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.02em]">Six visits, <span className="italic text-[#6B2D2A]">six months</span>.</h1>
        <p className="font-serif italic text-lg lg:text-xl text-[#1F1E1B]/65 mt-6 max-w-2xl">No commission has ever taken less than five months. We do not promise faster, and on the whole, we are politely refused by people who want it sooner.</p>
      </section>

      <section className="relative max-w-[1100px] mx-auto px-8 lg:px-14 py-20">
        <div className="space-y-1">
          {FITTINGS.map((f, i) => (
            <motion.div key={f.n} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
              className="grid grid-cols-[80px_1fr] lg:grid-cols-[140px_1fr] gap-6 lg:gap-12 py-10 border-t-2 border-[#1F1E1B]/40">
              <div>
                <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#6B2D2A]">{f.n}</p>
                <p className="font-serif text-7xl lg:text-9xl text-[#6B2D2A] leading-none italic">{['I', 'II', 'III', 'IV', 'V', 'VI'][i]}</p>
              </div>
              <div>
                <h2 className="font-serif text-3xl lg:text-5xl leading-[1] mb-4" dangerouslySetInnerHTML={{ __html: f.t }} />
                <p className="font-serif text-base lg:text-lg text-[#1F1E1B]/85 leading-[1.7] max-w-2xl" dangerouslySetInnerHTML={{ __html: f.d }} />
                <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#6B2D2A]/85 mt-4">/ Approximate week · {[1, 4, 7, 10, 14, 18][i]}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="relative bg-[#1F1E1B] text-[#E5DDCB] py-20">
        <div className="max-w-[820px] mx-auto px-8 lg:px-14 text-center">
          <p className="font-serif text-3xl lg:text-5xl leading-[1.15]">A suit, then. <span className="italic text-[#6B2D2A]">Six fittings hence</span>.</p>
          <button onClick={() => setPage('appointment')} className="mt-10 bg-[#6B2D2A] text-[#E5DDCB] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#E5DDCB] hover:text-[#1F1E1B] transition-colors">Book your first fitting →</button>
        </div>
      </section>
    </div>
  );
}
